import type { ReactElement } from "react";

import type { TIconProps } from "./types";

export const Organization = (props: TIconProps): ReactElement => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
        fill="hsl(from hsl(var(--primary)) h s 50%)"
      />
      <path
        d="M32.1043 27.3212H21.059L15.4127 55.0838H32.1043H48.7995L43.1532 27.3212H32.1043Z"
        fill="url(#paint0_linear_147_9530)"
      />
      <path
        d="M44.3941 23.7983C44.4126 23.5287 44.4236 23.2555 44.4236 22.9822C44.4236 16.18 38.9102 10.6666 32.1081 10.6666C25.3059 10.6666 19.7925 16.18 19.7925 22.9822C19.7925 23.2555 19.8035 23.5287 19.822 23.7983H44.3941Z"
        fill="hsl(from hsl(var(--primary)) h s 85%)"
      />
      <path
        d="M31.9642 11.6747C25.9486 11.6747 21.0741 16.5529 21.0741 22.5649C21.0741 22.6276 21.0778 22.6904 21.0778 22.7532H22.6509C23.3526 17.4171 27.9169 13.2959 33.4451 13.2959C36.2369 13.2959 38.7849 14.3483 40.7126 16.0766C38.7295 13.403 35.55 11.671 31.9642 11.671V11.6747Z"
        fill="white"
      />
      <path
        d="M32.1045 23.4734H18.6663L5.53088 31.1656H32.1045H58.6817L45.5464 23.4734H32.1045Z"
        fill="hsl(from hsl(var(--primary)) h s 33%)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_147_9530"
          x1={32.1043}
          y1={28.6986}
          x2={32.1043}
          y2={54.9694}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="hsl(from hsl(var(--primary)) h s 57%)" />
        </linearGradient>
      </defs>
    </svg>
  );
};
